import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CheckoutForm } from './PaymentPage';
import React, { useState, useCallback } from 'react';
import { isWhitelabelBrand, useBranding } from '../hooks/useBranding';
import WhitelabelUpgradeContact from 'modules/Common/ui/WhitelabelUpgradeContact';

let priceId;
if (process.env.REACT_APP_ENV_MODE == 'PROD') {
  priceId = 'price_1TByCyRwsLdKL2q4MmdH9mNa';
} else {
  priceId = 'price_1TByCYRwsLdKL2q4vwz68Zen';
}

const UpgradePage = () => {
  const history = useHistory();
  const brand = useBranding();

  // The checkout below is CG's own Stripe account against a hardcoded CG
  // priceId, so it quotes CG's rates. PaymentPage guards its own page body,
  // but this route imports CheckoutForm DIRECTLY and so bypassed that guard —
  // a whitelabel user clicking "Upgrade" in the freemium banner landed on CG
  // pricing. Whitelabel tenants get their own support contact instead.
  if (isWhitelabelBrand(brand)) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center py-4 px-4">
        <WhitelabelUpgradeContact />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-4 px-[200px]">
      <div className="w-full mt-4 space-y-8">
        {
          <CheckoutForm
            priceId={priceId}
            quantity={1}
            onClose={() => {
              history.goBack();
            }}
          />
        }
      </div>
    </div>
  );
};

export default UpgradePage;
